<template>
  <hm-content title="">
    <div class="mb10 flex flex-between">
      <el-button type="primary" size="small" @click="addAct"
        >月度目标管理基础配置</el-button
      >
      <div>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.targetName"
          placeholder="请输入门店名称/导购工号"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-select
          size="small"
          clearable
          placeholder="请选择目标类型"
          v-model="searchCondition.targetType"
          class="mr10"
          filterable
        >
          <el-option
            :label="v.itemText"
            :value="v.itemValue"
            v-for="(v, i) in targetTypeList"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="请选择目标范围"
          v-model="searchCondition.targetRange"
          class="mr10"
          filterable
        >
          <el-option
            :label="v.itemText"
            :value="v.itemValue"
            v-for="(v, i) in targetRangeList"
            :key="i"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出报表</el-button
        >
      </div>
    </div>
    <!-- <div class="flex flex-end mt10 mb10">
      <span @click="batchDelete" class="pointer">
        <span class="delete-icon hmicon icon-shanchu"></span>批量删除
      </span>
    </div> -->
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="targetTypeName"
          label="目标类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.targetType === 'new-member'">
              新客开发
            </div>
            <div v-if="scope.row.targetType === 'wxshop-sale'">
              微店销售业绩
            </div>
            <div v-if="scope.row.targetType === 'offline-sale'">
              线下销售业绩
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="targetRangeName"
          label="目标范围"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.targetRange === 'whole'">
              全局
            </div>
            <div v-if="scope.row.targetRange === 'shop'">
              门店
            </div>
            <div v-if="scope.row.targetRange === 'employee'">
              职员
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="targetName"
          label="对象"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="targetMonth"
          label="目标年月"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="targetValue"
          label="目标值"
        >
          <template slot-scope="scope">
            <div @dblclick="editEnddate(scope.$index, scope.row)">
              <div v-show="scope.row.edit_enddate" class="blue pointer">
                {{ scope.row.targetValue }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="双击修改"
                  placement="right-start"
                >
                  <span class="hmicon icon-shuru blue pointer"> </span>
                </el-tooltip>
              </div>
              <el-input
                :ref="'enddateinputs' + scope.$index"
                @blur="editdateblur(scope.$index, scope.row)"
                @keyup.enter.native="$event.target.blur"
                clearable
                v-show="!scope.row.edit_enddate"
                size="mini"
                style="width:100%"
                v-model="scope.row.targetValue"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actualValue"
          label="达成值"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="autoOfflineDaysLimt"
          label="达成率"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.targetValue != 0">
              {{
                Math.round(scope.row.actualValue / scope.row.targetValue) * 100
              }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="创建人"
        >
        </el-table-column>
        <!-- <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="edit(scope.row)"
              >修改目标值</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="月度目标管理基础配置"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <el-dialog
        title="自定义"
        :visible.sync="innerVisible"
        append-to-body
        width="800px"
      >
        <div>
          <el-table
            stripe
            border
            ref="table"
            :data="targetList"
            style="width: 100%"
            id="table"
            size="small"
            height="500"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
              :index="
                index => index + (currentPagetarget - 1) * pageSizetarget + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="targetTypeNmae"
              label="目标类型"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="targetValue"
              label="目标值"
            >
              <template slot-scope="scope">
                <div @dblclick="changeEnddate(scope.$index, scope.row)">
                  <span v-show="scope.row.edit_enddate" class="blue pointer"
                    >{{ scope.row.targetValue }}
                    <!-- <span class="hmicon icon-shuru blue pointer"> </span> -->
                  </span>
                  <el-input
                    :ref="'enddateinput' + scope.$index"
                    @blur="enddateblur(scope.$index, scope.row)"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!scope.row.edit_enddate"
                    size="mini"
                    style="width:100%"
                    v-model="scope.row.targetValue"
                    placeholder="请输入内容"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsCount"
              label="目标年"
            >
              <template slot-scope="scope">
                {{ year }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsCount"
              label="目标月"
            >
              <template slot-scope="scope">
                {{ month }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="targetRangeName"
              label="目标范围"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="targetName"
              label="目标对象"
            >
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="targetTotal"
              @current-change="pagingtarget"
              @size-change="handleSizeChangetarget"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPagetarget"
            ></el-pagination>
          </div>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button size="small" type="primary" @click="innerVisible = false"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
      <div class="target-configuration mb20">
        以月度为单位配置每月不同目标，设置后每月1日自动生成当月目标值，若有修改，在目标管理页面直接修改即可。
        若要调整基础目标生成值，在此处修改即可，修改后下月生效
      </div>
      <div class="table">
        <el-table
          stripe
          border
          ref="table"
          :data="defaultList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column header-align="center" align="center" type="index">
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="targetTypeName"
            label="目标类型"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="targetRangeName"
            label="目标范围"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="targetValue"
            label="默认目标值"
          >
            <template slot-scope="scope">
              <el-input
                clearable
                style="width:200px"
                v-model="scope.row.targetValue"
                maxlength="20"
                size="small"
                placeholder="请输入指标值,仅支持整数"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.targetRange !== 'whole'"
                @click="custom(scope.row)"
                >自定义</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="目标类型" prop="targetType">
          <el-select
            size="small"
            clearable
            placeholder="请选择目标类型"
            v-model="ruleForm.targetType"
            class="mr10"
            filterable
            @change="targetTypeChange"
          >
            <el-option
              :label="v.itemText"
              :value="v.itemValue"
              v-for="(v, i) in targetTypeList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标范围" prop="targetRange">
          <el-select
            size="small"
            clearable
            placeholder="请选择目标范围"
            v-model="ruleForm.targetRange"
            class="mr10"
            filterable
            @change="targetRangeChange"
          >
            <el-option
              :label="v.itemText"
              :value="v.itemValue"
              v-for="(v, i) in targetRangeList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指标值" prop="targetValue">
          <el-input
            clearable
            v-model="ruleForm.targetValue"
            maxlength="20"
            size="small"
            placeholder="请输入指标值,仅支持整数"
          ></el-input>
        </el-form-item>
      </el-form> -->
      <span slot="footer" class="dialog-footer flex flex-center">
        <!-- <el-button size="small" type="primary" @click="preview('ruleForm')"
          >预 览</el-button
        > -->
        <el-button size="small" type="primary" @click="save('ruleForm')"
          >确 认</el-button
        >
        <el-button size="small" type="info" @click="dialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      targetValue: "",
      defaultList: [],
      targetRangeList: [],
      targetTypeList: [],
      innerVisible: false,
      employeeList: [],
      shopList: [],
      ruleForm: {
        targetTypeName: "",
        targetRangeName: "",
        targetType: "",
        targetRange: "",
        targetValue: ""
      },
      rules: {
        targetType: {
          required: true,
          trigger: "change",
          message: "请选择目标范围"
        },
        targetRange: {
          required: true,
          trigger: "change",
          message: "请选择目标类型"
        },
        targetValue: {
          required: true,
          trigger: "change",
          message: "请输入指标值"
        }
      },
      isOutputing: false,
      dialogVisible: false,
      total: 0,
      list: [],
      targetList: [],
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        targetName: "",
        targetType: "",
        targetRange: ""
      },
      checkedDelRow: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      customRow: {},
      targetTotal: 0,
      currentPagetarget: 1,
      pageSizetarget: 10
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryTargetTypeList();
    this.queryTargetRangeList();
    this.queryAllShopList();
    this.queryAllEmployeeList();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    enddateblur(index, rowdata) {
      if (
        rowdata.targetValue === "" ||
        rowdata.targetValue === this.editwxName
      ) {
        rowdata.targetValue = this.editwxName;
        this.targetList = [...this.targetList];
      } else {
        let flag = false;

        if (rowdata.targetValue === "" && rowdata.targetValue !== 0) {
          flag = true;
        }
        if (flag) {
          this.$message({
            message: "请输入默认指标值",
            type: "warning"
          });
        } else {
          this.$store.dispatch("saveTargetRangeInfo", [rowdata]).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.queryTargetList();
            }
          });
        }
      }
      this.targetList[index].edit_enddate = !this.targetList[index]
        .edit_enddate;
    },
    editEnddate(index, rowdata) {
      this.targetValue = rowdata.targetValue;
      this.list[index].edit_enddate = !this.list[index].edit_enddate; //直接加key
      this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinputs" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    editdateblur(index, rowdata) {
      if (
        rowdata.targetValue === "" ||
        rowdata.targetValue === this.targetValue
      ) {
        rowdata.targetValue = this.targetValue;
        this.list = [...this.list];
      } else {
        let flag = false;

        if (rowdata.targetValue === "" && rowdata.targetValue !== 0) {
          flag = true;
        }
        if (flag) {
          this.$message({
            message: "请输入指标值",
            type: "warning"
          });
        } else {
          this.$store.dispatch("editTargetRangeInfo", rowdata).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
        }
      }
      this.list[index].edit_enddate = !this.list[index].edit_enddate;
    },
    changeEnddate(index, rowdata) {
      this.editwxName = rowdata.targetValue;
      this.targetList[index].edit_enddate = !this.targetList[index]
        .edit_enddate; //直接加key
      this.targetList = [...this.targetList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    async custom(row) {
      this.innerVisible = true;
      this.customRow = row;
      this.queryTargetList();
    },
    async queryTargetList() {
      let params = {
        pageSize: this.pageSizetarget,
        pageNo: this.currentPagetarget,
        targetRange: this.customRow.targetRange,
        targetType: this.customRow.targetType,
        manageType: "sale"
      };

      const { result } = await this.$store.dispatch(
        "queryTargetManageList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.edit_enddate = true;
        v.targetRangeName = this.targetRangeList.find(
          o => o.itemValue === v.targetRange
        ).itemText;
        v.targetTypeNmae = this.targetTypeList.find(
          o => o.itemValue === v.targetType
        ).itemText;
      });
      this.targetList = records;
      this.targetTotal = total;
    },
    pagingtarget(page) {
      this.currentPagetarget = page;
      this.queryTargetList();
    },
    handleSizeChangetarget(size) {
      this.currentPagetarget = 1;
      this.pageSizetarget = size;
      this.queryTargetList();
    },
    targetTypeChange(val) {
      this.ruleForm.targetTypeName = val
        ? this.targetTypeList.find(ele => ele.itemValue === val).itemText
        : "";
    },
    targetRangeChange(val) {
      this.ruleForm.targetRangeName = val
        ? this.targetRangeList.find(ele => ele.itemValue === val).itemText
        : "";
    },
    async queryAllShopList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      const { result } = await this.$store.dispatch("queryShopList", params);
      this.shopList = result.records;
    },
    async queryAllEmployeeList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        workingState: "yes",
        loginType: "store"
      };
      const { result } = await this.$store.dispatch(
        "queryEmployeeList",
        params
      );
      this.employeeList = result.records;
    },
    async queryTargetTypeList() {
      const { result } = await this.$store.dispatch("queryTargetTypeList");
      this.targetTypeList = result;
    },
    async queryTargetRangeList() {
      const { result } = await this.$store.dispatch("queryTargetRangeList");
      this.targetRangeList = result;
    },
    async queryDefaultList() {
      const { result } = await this.$store.dispatch("queryDefaultList");
      return result;
    },
    resetRuleForm() {
      setTimeout(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
      }, 0);
    },
    save() {
      let flag = false;
      this.defaultList.forEach(v => {
        if (v.targetValue === "" && v.targetValue !== 0) {
          flag = true;
        }
      });
      if (flag) {
        this.$message({
          message: "请输入默认指标值",
          type: "warning"
        });
      } else {
        this.$store
          .dispatch("saveTargetRangeInfo", this.defaultList)
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.queryList();
              this.dialogVisible = false;
            }
          });
      }
    },
    preview(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          this.innerVisible = true;
          if (params.targetRange === "whole") {
            params.targetObject = "全局";
            params.manageType = "sale";
            this.targetList = [params];
          } else if (params.targetRange === "shop") {
            this.shopList.forEach(v => {
              v.targetObject = v.shopName;
              v.manageType = "sale";

              Object.assign(v, params);
            });
            this.targetList = this.shopList;
          } else if (params.targetRange === "employee") {
            this.employeeList.forEach(v => {
              v.targetObject = v.realname;
              v.manageType = "sale";
              Object.assign(v, params);
            });
            this.targetList = this.employeeList;
          }
          //   this.$store.dispatch("editWxMsgTemplateInfo", params).then(res => {
          //     if (res.code === "0") {
          //       this.$message({
          //         message: "操作成功",
          //         type: "success"
          //       });
          //       this.resetRuleForm();
          //       this.queryList();
          //       this.dialogVisible = false;
          //     }
          //   });
        } else {
          return false;
        }
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res;
            list.forEach(v => {
              if (v.targetType === "new-member") {
                v.targetTypeName = "新客开发";
              } else if (v.targetType === "wxshop-sale") {
                v.targetTypeName = "微店销售业绩";
              } else if (v.targetType === "offline-sale") {
                v.targetTypeName = "线下销售业绩";
              }
              if (v.targetRange === "whole") {
                v.targetRangeName = "全局";
              } else if (v.targetRange === "shop") {
                v.targetRangeName = "门店";
              } else if (v.targetRange === "employee") {
                v.targetRangeName = "职员";
              }
              if (v.targetValue != 0) {
                v.autoOfflineDaysLimt =
                  Math.round(v.actualValue / v.targetValue) * 100 + "%";
              }
              // if (v.actCostMoney && !v.actCostIntegral) {
              //   v.cost = `${v.actCostMoney}元`;
              // } else if (v.actCostMoney && v.actCostIntegral) {
              //   v.cost = `${v.actCostMoney}元/${v.actCostIntegral}积分`;
              // } else if (v.actCostIntegral && !v.actCostMoney) {
              //   v.cost = `${v.actCostIntegral}积分`;
              // } else {
              //   v.cost = "免费";
              // }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            //  {{ scope.row.realApplyNum }}/{{ scope.row.actMemberUpperLimit }}
            // const tHeader = [
            //   "活动名称",
            //   "活动日期",
            //   "报名时间",
            //   "地点",
            //   "报名人数",
            //   "适合人群",
            //   "主图",
            //   "状态"
            // ];
            // const filterVal = [
            //   "actName",
            //   "actDate",
            //   "applyDate",
            //   "actSite",
            //   "realApplyNums",
            //   "suitPerson",
            //   "mainImgUrl",
            //   "timeStatusFormat"
            // ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "目标管理列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    getDelChecked(selection) {
      this.checkedDelRow = selection.map(v => v.rewardRuleId);
    },
    batchDelete() {
      if (this.checkedDelRow.length) {
        let say = "删除已选" + this.checkedDelRow.length + "条数据";
        this.$confirm(say, "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }).then(() => {
          //   let params = {
          //     rewardRuleIds: this.checkedDelRow,
          //     supplierCode: this.$route.query.storeCode
          //   };
          //   this.$store
          //     .dispatch("delSupplierRewardRuleInfoList", params)
          //     .then(res => {
          //       if (res.code === "0") {
          //         this.$message({
          //           message: " 操作成功",
          //           type: "success"
          //         });
          //         this.queryList();
          //       }
          //     });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },

    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        manageType: "sale"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      // if (params.targetName !== "") {
      //   if (params.targetType === "" || params.targetRange === "") {
      //     this.$message({
      //       message: "请先选择目标类型或目标范围",
      //       type: "warning"
      //     });
      //   }
      // } else {
      const { result } = await this.$store.dispatch(
        "queryTargetMonthlyList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.edit_enddate = true;
      });
      this.list = records;
      this.total = total;
      // }
    },
    async queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        manageType: "sale"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAllTargetMonthlyList",
        params
      );
      const { records } = result;
      return records;
      // this.list = records;
      // this.list.forEach(v => {
      //   v.targetRangeName = this.targetRangeList.find(
      //     o => o.itemValue === v.targetRange
      //   ).itemText;
      //   v.targetTypeName = this.targetTypeList.find(
      //     o => o.itemValue === v.targetType
      //   ).itemText;
      // });
    },
    addAct() {
      this.resetRuleForm();
      this.dialogVisible = true;
      this.defaultList = [];
      this.queryDefaultList().then(res => {
        if (res.length) {
          res.forEach(v => {
            v.targetRangeName = this.targetRangeList.find(
              o => o.itemValue === v.targetRange
            ).itemText;
            v.targetTypeNmae = this.targetTypeList.find(
              o => o.itemValue === v.targetType
            ).itemText;
          });
          this.defaultList = res;
        } else {
          this.targetTypeList.forEach(v => {
            v.targetTypeNmae = v.itemText;
            v.targetType = v.itemValue;
            this.targetRangeList.forEach(j => {
              j.targetRange = j.itemValue;
              j.targetRangeName = j.itemText;

              this.defaultList.push({
                targetTypeNmae: v.itemText,
                targetType: v.itemValue,
                targetRangeName: j.itemText,
                targetRange: j.itemValue,
                targetValue: 0,
                targetId: "default",
                manageType: "sale"
              });
            });
          });
        }
      });
    },
    filterGt0OrListFixed0(i, prop) {
      //   if (prop !== "rewardSubNum") {
      //     this.defaultList[i][prop] = this.defaultList[i][prop].replace(
      //       /^(0+)/,
      //       ""
      //     ); //过滤0开头
      //   }

      this.defaultList[i][prop] = this.defaultList[i][prop].replace(
        /[^\d]+/g,
        ""
      );
      this.defaultList[i][prop] = this.defaultList[i][prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.target-configuration {
  background: rgba(245, 251, 255, 1);
  border: 1px solid rgba(107, 190, 255, 1);
  border-radius: 4px;
  line-height: 20px;
  padding: 10px;
  color: #0081e5;
}
</style>
